window.DemandEditorToolbar = {
    dotNetRef: null,
    editorId: null,
    retryCount: 0,
    maxRetries: 50,

    initialize: function (dotNetRef, editorId) {
        this.dotNetRef = dotNetRef;
        this.editorId = editorId;
        this.retryCount = 0;
        this.interceptToolbarButtons();
    },

    interceptToolbarButtons: function () {
        if (this.retryCount >= this.maxRetries) {
            return;
        }

        this.retryCount++;

        const editorElement = document.getElementById(this.editorId);
        if (!editorElement) {
            setTimeout(() => this.interceptToolbarButtons(), 300);
            return;
        }

        const toolbarElement = editorElement.querySelector('.e-toolbar');
        if (!toolbarElement) {
            setTimeout(() => this.interceptToolbarButtons(), 300);
            return;
        }

        toolbarElement.addEventListener('click', (event) => {
            let target = event.target.closest('.e-toolbar-item')
                || event.target.closest('[role="button"]')
                || event.target.closest('button');

            if (!target) return;

            const itemId    = target.getAttribute('id')          || '';
            const title     = target.getAttribute('title')       || '';
            const ariaLabel = target.getAttribute('aria-label')  || '';
            const innerText = target.innerText                   || '';

            const isOpen = itemId.toLowerCase().includes('open')
                || title.toLowerCase().includes('open')
                || ariaLabel.toLowerCase().includes('open')
                || innerText.toLowerCase().includes('open');

            if (isOpen) {
                this.dotNetRef.invokeMethodAsync('OnOpenButtonClicked')
                    .catch(() => {});
            }
        }, true);
    }
};
